import { ErrorCodeEnum } from '@core/enums/error-code.enum';
import { IError } from '@core/models/interfaces/error.interface';

export interface ILoginError {
  error: string;
  errorDescription: string | undefined;
  correlationId: string;
}

export interface ITokenData {
  idToken: string;
  accessToken: string;
  refreshToken: string;
}

/** Payload of `sessionEvents.hydrated`: the tokens read from localStorage. */
export type IHydratedSession = ITokenData;

/** Normalized `error` value: the session is no longer valid and login must be retried. */
export const SESSION_EXPIRED_ERROR = 'session_expired';

/**
 * Normalizes an authentication failure into the model the login page renders. OAuth errors
 * (body `{ error, error_description }` from the token endpoint) keep their own code, while
 * every other failure (retried request 401, INVALID_NONCE, empty body) degrades to
 * `session_expired` → "Sessione scaduta" copy on the login page.
 */
export const createLoginError = (oauthError?: IError | string): ILoginError => ({
  error: typeof oauthError === 'string' ? SESSION_EXPIRED_ERROR
    : (oauthError?.error ?? SESSION_EXPIRED_ERROR),
  errorDescription: typeof oauthError === 'string' ? undefined : oauthError?.error_description,
  correlationId: (typeof oauthError === 'object' ? oauthError?.correlation_id : undefined)
    ?? globalThis.crypto?.randomUUID?.() ?? Date.now().toString(36)
});

export interface AppErrorState {
  errorCode: ErrorCodeEnum | undefined;
  loginError: ILoginError | undefined;
}

export const INITIAL_APP_ERROR_STATE: AppErrorState = {
  errorCode: undefined,
  loginError: undefined
};

export const resetAppError = (): AppErrorState => ({ ...INITIAL_APP_ERROR_STATE });
